var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteiconsSvg11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2620_1308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0486 49.274C38.4549 49.274 49.3228 38.406 49.3228 24.9998C49.3228 11.5935 38.4549 0.725586 25.0486 0.725586C11.6423 0.725586 0.774414 11.5935 0.774414 24.9998C0.774414 38.406 11.6423 49.274 25.0486 49.274Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0862 34.0957C12.0179 31.6033 10.8609 28.4804 10.8058 25.2421C10.7507 22.0037 11.8008 18.8433 13.783 16.2819C15.7652 13.7205 18.5611 11.9111 21.7097 11.1521C24.8583 10.393 28.1716 10.7297 31.1032 12.1065C34.0348 13.4833 36.4096 15.818 37.8362 18.7257C39.2627 21.6334 39.6558 24.9405 38.9505 28.1015C38.2452 31.2626 36.4837 34.089 33.9565 36.1145C31.4292 38.1401 28.2871 39.2439 25.0483 39.244",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5127 35.2311H15.6572L15.4747 29.3911",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3604 15.3828V24.9998H30.1058",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2620_1308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.0488281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteiconsSvg11);
export default __webpack_public_path__ + "static/media/Website icons SVG-11.5179bfc0bd6bd7df9028cbc1e4ed3275.svg";
export { ForwardRef as ReactComponent };